module.exports = __webpack_public_path__ + "img/20191023165111549.8d37cb3a.jpg";